import React from 'react';
import {Text} from '@chakra-ui/react';
import {IntentSignals} from './IntentSignals';
import {IntentTiers} from './IntentTiers';

export const IntentTabs = [
  {
    label: <Text>Tiers</Text>,
    path: 'tiers',
    element: <IntentTiers />,
  },
  {
    label: <Text>Signals</Text>,
    path: 'signals',
    element: <IntentSignals />,
  },
] as const;
